const BeerRainButton = () => {
  const handleBeerRain = () => {
    for (let i = 0; i < 20; i++) {
      const el = document.createElement("div");
      el.style.position = "fixed";
      el.style.left = `${Math.random() * 100}vw`;
      el.style.top = `-50px`;
      el.style.fontSize = "2rem";
      el.style.animation = `fall ${2 + Math.random() * 2}s linear`;
      el.style.pointerEvents = "none";

      const isBeer = Math.random() < 0.5;

      if (isBeer) {
        el.textContent = "🍺";
      } else {
        const img = document.createElement("img");
        img.src = "https://cdn-icons-png.flaticon.com/512/7499/7499501.png";
        img.style.width = "40px";
        img.style.height = "40px";
        img.style.userSelect = "none";
        el.appendChild(img);
      }

      document.body.appendChild(el);
      setTimeout(() => el.remove(), 5000);
    }
  };

  return (
    <button
      className="beer-button"
      type="button"
      onClick={handleBeerRain}
      aria-label="Beer rain"
    >
      🍺
    </button>
  );
};

export default BeerRainButton;
